
<script>
	import listBase from '@_system/components/base/list.vue'
	import Static from './static/index.vue'
	export default {
		extends: listBase,
		name: 'recommendIndex',
		render(h) {
			this.$slots.header = [
				<div style="position: relative;width: 100%;height:100%">
					<Static />
				</div>
			]
			return listBase.render.call(this, h)
		},
		props: {

		},
		data() {
			return {
				moduleName: 'recommend',
				windowName: '推荐客户单',
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {

		},
		components: {

		}
	}
</script>
